import appFeatures from "@/appFeatures";

/**
 * Hook to access application feature flags
 * @returns `appFeatures` Object containing feature flags
 */
export const useAppFeatures = () => appFeatures;
